import { render, staticRenderFns } from "./QuizCounter.vue?vue&type=template&id=47d87577&"
import script from "./QuizCounter.vue?vue&type=script&lang=js&"
export * from "./QuizCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports